(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var overlay = document.querySelector('[data-cart-drawer-overlay]');
    var drawer = document.querySelector('[data-cart-drawer]');
    var closeButton = document.querySelector('[data-cart-drawer-close]');
    var triggers = document.querySelectorAll('[data-cart-drawer-trigger]');
    var focusReturnTarget = null;

    if (!overlay || !drawer || !closeButton) return;

    function openDrawer() {
      if (!document.body.classList.contains('cart-drawer-open')) {
        focusReturnTarget = document.activeElement;
      }
      document.body.classList.add('cart-drawer-open');
      document.body.style.overflow = 'hidden';
      drawer.inert = false;
      drawer.setAttribute('aria-hidden', 'false');
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      });
      closeButton.focus();
    }

    function closeDrawer() {
      var wasOpen = document.body.classList.contains('cart-drawer-open');
      document.body.classList.remove('cart-drawer-open');
      document.body.style.overflow = '';
      drawer.inert = true;
      drawer.setAttribute('aria-hidden', 'true');
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });

      if (wasOpen) {
        var target = focusReturnTarget && focusReturnTarget.isConnected
          ? focusReturnTarget
          : triggers[0];
        if (target) target.focus();
        focusReturnTarget = null;
      }
    }

    overlay.addEventListener('click', closeDrawer);
    closeButton.addEventListener('click', closeDrawer);

    document.addEventListener('cart-drawer:open', openDrawer);
    document.addEventListener('cart-drawer:close', closeDrawer);

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openDrawer();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (!document.body.classList.contains('cart-drawer-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusableElements = drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      var focusable = Array.prototype.filter.call(focusableElements, function (element) {
        return !element.hidden && element.getClientRects().length > 0;
      });

      if (!focusable.length) {
        event.preventDefault();
        drawer.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    });

    function formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: drawer.dataset.currency
      }).format(cents / 100);
    }

    // Mirrors Liquid's `money` filter so upsell prices match the product cards.
    // Accepts cents, or a decimal string such as "12.00".
    function formatStoreMoney(price) {
      var cents = typeof price === 'string' && price.indexOf('.') !== -1
        ? Math.round(parseFloat(price) * 100)
        : Number(price);
      var format = drawer.dataset.moneyFormat;
      if (!format || isNaN(cents)) return formatMoney(cents);

      function withSeparators(number, decimals, thousands, decimal) {
        var fixed = (number / 100).toFixed(decimals).split('.');
        var whole = fixed[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return fixed[1] ? whole + decimal + fixed[1] : whole;
      }

      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
        switch (name) {
          case 'amount': return withSeparators(cents, 2, ',', '.');
          case 'amount_no_decimals': return withSeparators(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return withSeparators(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return withSeparators(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return withSeparators(cents, 2, '\'', '.');
          case 'amount_no_decimals_with_space_separator': return withSeparators(cents, 0, ' ', '.');
          case 'amount_with_space_separator': return withSeparators(cents, 2, ' ', ',');
          case 'amount_with_period_and_space_separator': return withSeparators(cents, 2, ' ', '.');
          default: return match;
        }
      });
    }

    function renderUpsells(products) {
      var upsells = drawer.querySelector('[data-cart-upsells]');
      var grid = drawer.querySelector('[data-cart-upsells-grid]');
      if (!upsells || !grid) return;

      var productsHtml = products
        .filter(function (product) {
          return product.variants && product.variants.length && product.featured_image;
        })
        .slice(0, 2)
        .map(function (product) {
          var variant = product.variants.find(function (item) { return item.available; }) || product.variants[0];
          if (!variant) return '';

          return (
            '<article class="cart-drawer__upsell">' +
              '<div class="cart-drawer__upsell-media">' +
                '<a href="' + product.url + '" class="cart-drawer__upsell-image-link">' +
                  '<img src="' + product.featured_image + '" alt="" class="cart-drawer__upsell-image" loading="lazy" width="96" height="96">' +
                '</a>' +
                '<form action="' + drawer.dataset.cartAddUrl + '" method="post" class="cart-drawer__upsell-form">' +
                  '<input type="hidden" name="id" value="' + variant.id + '">' +
                  '<input type="hidden" name="quantity" value="1">' +
                  '<button type="submit" class="cart-drawer__upsell-button" data-loading-label="' + drawer.dataset.addingLabel + '"><span class="button__label">' + drawer.dataset.addToCartLabel + '</span><span class="button__price">' + formatStoreMoney(variant.price) + '</span></button>' +
                '</form>' +
              '</div>' +
              '<div class="cart-drawer__upsell-details">' +
                '<a href="' + product.url + '" class="cart-drawer__upsell-title">' + escapeHtml(product.title) + '</a>' +
              '</div>' +
            '</article>'
          );
        })
        .join('');

      grid.innerHTML = productsHtml;
      upsells.hidden = !productsHtml;
    }

    function loadUpsells() {
      var recommendationsUrl = drawer.dataset.recommendationsUrl;
      if (!recommendationsUrl || !drawer.querySelector('[data-cart-upsells]')) return;

      fetch(recommendationsUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : Promise.reject(response); })
        .then(function (data) { renderUpsells(data.products || []); })
        .catch(function () {});
    }

    function escapeHtml(value) {
      var div = document.createElement('div');
      div.textContent = value || '';
      return div.innerHTML;
    }

    var trashIcon = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.99967H3.33333M3.33333 3.99967H14M3.33333 3.99967L3.33333 13.333C3.33333 13.6866 3.47381 14.0258 3.72386 14.2758C3.97391 14.5259 4.31304 14.6663 4.66667 14.6663H11.3333C11.687 14.6663 12.0261 14.5259 12.2761 14.2758C12.5262 14.0258 12.6667 13.6866 12.6667 13.333V3.99967M5.33333 3.99967V2.66634C5.33333 2.31272 5.47381 1.97358 5.72386 1.72353C5.97391 1.47348 6.31304 1.33301 6.66667 1.33301H9.33333C9.68696 1.33301 10.0261 1.47348 10.2761 1.72353C10.5262 1.97358 10.6667 2.31272 10.6667 2.66634V3.99967M6.66667 7.33301V11.333M9.33333 7.33301V11.333" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function renderItem(item) {
      var variantRow = item.variant_title
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';

      return (
        '<div class="cart-drawer__item" data-cart-item data-item-key="' + item.key + '">' +
          '<div class="cart-drawer__item-image">' +
            '<a href="' + item.url + '"><img src="' + item.image + '" alt="" width="80" height="80"></a>' +
          '</div>' +
          '<div class="cart-drawer__item-details">' +
            '<p class="cart-drawer__item-title"><a href="' + item.url + '">' + escapeHtml(item.product_title) + '</a></p>' +
            variantRow +
            '<div class="cart-drawer__stepper" data-quantity-wrapper>' +
              '<button type="button" class="cart-drawer__stepper-button" data-quantity-decrease aria-label="' + drawer.dataset.decreaseLabel + '">−</button>' +
              '<span class="cart-drawer__stepper-value" data-quantity-value>' + item.quantity + '</span>' +
              '<button type="button" class="cart-drawer__stepper-button" data-quantity-increase aria-label="' + drawer.dataset.increaseLabel + '">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-drawer__item-quantity">' +
            '<button type="button" class="cart-drawer__item-remove" data-cart-remove aria-label="' + drawer.dataset.removeLabel + '">' + trashIcon + '</button>' +
            '<p class="cart-drawer__item-price" data-item-price>' + formatStoreMoney(item.final_line_price) + '</p>' +
          '</div>' +
        '</div>'
      );
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
        var number = badge.querySelector('[data-cart-count-number]');
        if (number) number.textContent = count;
        badge.hidden = count === 0;
      });
    }

    function renderCart(cartData) {
      updateCartCount(cartData.item_count);
      var body = drawer.querySelector('[data-cart-items]') || drawer.querySelector('.cart-drawer__body');
      var footer = drawer.querySelector('.cart-drawer__footer');

      if (cartData.item_count === 0) {
        body.outerHTML = '<div class="cart-drawer__body"><p class="cart-drawer__empty">' + drawer.dataset.emptyLabel + '</p></div>';
        if (footer) footer.remove();
        return;
      }

      var itemsHtml = cartData.items.map(renderItem).join('');
      body.outerHTML = '<div class="cart-drawer__body" data-cart-items>' + itemsHtml + '</div>';

      if (footer) {
        var subtotal = footer.querySelector('[data-cart-subtotal]');
        if (subtotal) subtotal.textContent = formatStoreMoney(cartData.total_price);
        var itemCountLabel = footer.querySelector('[data-cart-item-count-label]');
        if (itemCountLabel) {
          var template = cartData.item_count === 1 ? drawer.dataset.itemCountOne : drawer.dataset.itemCountOther;
          itemCountLabel.textContent = template.replace('__number__', cartData.item_count);
        }
        var checkoutLink = footer.querySelector('.cart-drawer__checkout');
        if (checkoutLink) checkoutLink.textContent = drawer.dataset.checkoutLabel + ' - ' + formatStoreMoney(cartData.total_price);
      } else {
        drawer.insertAdjacentHTML(
          'beforeend',
          '<div class="cart-drawer__footer">' +
            '<p class="cart-drawer__subtotal"><span>' + drawer.dataset.subtotalLabel + '</span><span data-cart-subtotal>' + formatStoreMoney(cartData.total_price) + '</span></p>' +
            '<form action="' + drawer.dataset.cartUrl + '" method="post"><button type="submit" name="checkout" class="button dark cart-drawer__checkout">' + drawer.dataset.checkoutLabel + ' - ' + formatStoreMoney(cartData.total_price) + '</button></form>' +
          '</div>'
        );
        refreshDrawerFromServer();
      }
    }

    // The drawer was rendered empty, so the notes, upsells and accelerated checkout are missing; pull them from a fresh server render
    function refreshDrawerFromServer() {
      fetch(window.location.href, { headers: { 'Accept': 'text/html' }, cache: 'no-store' })
        .then(function (response) { return response.ok ? response.text() : Promise.reject(response); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
          var header = drawer.querySelector('.cart-drawer__header');
          var freshHeader = fresh && fresh.querySelector('.cart-drawer__header');
          if (!fresh || !header || !freshHeader || !fresh.querySelector('.cart-drawer__footer')) return;

          while (header.nextSibling) drawer.removeChild(header.nextSibling);
          var node = freshHeader.nextSibling;
          while (node) {
            drawer.appendChild(document.importNode(node, true));
            node = node.nextSibling;
          }

          drawer.dataset.recommendationsUrl = fresh.dataset.recommendationsUrl;
          loadUpsells();
        })
        .catch(function () {});
    }

    function changeLineQuantity(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (response) { return response.json(); })
        .then(renderCart);
    }

    drawer.addEventListener('click', function (event) {
      var itemEl = event.target.closest('[data-cart-item]');
      if (!itemEl) return;

      var key = itemEl.dataset.itemKey;
      var valueEl = itemEl.querySelector('[data-quantity-value]');
      var current = parseInt(valueEl.textContent, 10) || 1;

      if (event.target.closest('[data-quantity-decrease]')) {
        var next = Math.max(1, current - 1);
        if (next !== current) changeLineQuantity(key, next);
      } else if (event.target.closest('[data-quantity-increase]')) {
        changeLineQuantity(key, current + 1);
      } else if (event.target.closest('[data-cart-remove]')) {
        changeLineQuantity(key, 0);
      }
    });

    var isCartPage = drawer.getAttribute('data-is-cart-page') === 'true';
    var cartAddUrl = drawer.getAttribute('data-cart-add-url');

    document.addEventListener('submit', function (event) {
      var form = event.target;

      if (!form || form.tagName !== 'FORM') return;
      if (form.action.indexOf(cartAddUrl) === -1) return;

      event.preventDefault();

      var submitButton = event.submitter || form.querySelector('[type="submit"]');
      var labelEl = submitButton && submitButton.querySelector('.button__label');
      var originalLabel = labelEl ? labelEl.textContent : (submitButton ? submitButton.textContent : '');

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        if (labelEl) {
          labelEl.textContent = submitButton.dataset.loadingLabel || originalLabel;
        } else {
          submitButton.textContent = submitButton.dataset.loadingLabel || originalLabel;
        }
      }

      function restoreButton() {
        if (!submitButton) return;
        submitButton.disabled = false;
        submitButton.classList.remove('is-loading');
        if (labelEl) {
          labelEl.textContent = originalLabel;
        } else {
          submitButton.textContent = originalLabel;
        }
      }

      var formData = new FormData(form);

      fetch(cartAddUrl, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) return Promise.reject(response);
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (response) { return response.json(); })
        .then(function (cartData) {
          renderCart(cartData);

          if (!isCartPage && !document.body.classList.contains('cart-drawer-open')) {
            openDrawer();
          }
        })
        .catch(function () {
          form.submit();
        })
        .finally(restoreButton);
    });

    loadUpsells();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-bar"] && !Shopify.designMode) return;
  try {
    const predictiveSearchWrappers = document.querySelectorAll('[data-predictive-search]');
  const predictiveSearchCache = new Map();

  predictiveSearchWrappers.forEach((wrapper) => {
    const input = wrapper.querySelector('input[type="search"]');
    const results = wrapper.querySelector('[data-predictive-search-results]');
    const baseUrl = wrapper.dataset.predictiveSearchUrl;

    if (!input || !results || !baseUrl) return;

    let debounceTimer;
    let activeController;

    const closeResults = () => {
      results.hidden = true;
      results.innerHTML = '';
    };

    // The predictive search API returns price as a decimal string (e.g. "12.00").
    // Mirrors Liquid's `money` filter so prices match the product cards.
    const formatPrice = (price) => {
      const amount = parseFloat(price);
      if (Number.isNaN(amount)) return price;

      const format = wrapper.dataset.moneyFormat;
      const withSeparators = (decimals, thousands, decimal) => {
        const [whole, fraction] = amount.toFixed(decimals).split('.');
        const grouped = whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        return fraction ? grouped + decimal + fraction : grouped;
      };
      const patterns = {
        amount: () => withSeparators(2, ',', '.'),
        amount_no_decimals: () => withSeparators(0, ',', '.'),
        amount_with_comma_separator: () => withSeparators(2, '.', ','),
        amount_no_decimals_with_comma_separator: () => withSeparators(0, '.', ','),
        amount_with_apostrophe_separator: () => withSeparators(2, "'", '.'),
        amount_no_decimals_with_space_separator: () => withSeparators(0, ' ', '.'),
        amount_with_space_separator: () => withSeparators(2, ' ', ','),
        amount_with_period_and_space_separator: () => withSeparators(2, ' ', '.')
      };

      if (format) {
        let matched = false;
        const result = format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, name) => {
          if (!patterns[name]) return match;
          matched = true;
          return patterns[name]();
        });
        if (matched) return result;
      }

      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: wrapper.dataset.currency
      }).format(amount);
    };

    const renderResults = (data, query) => {
      const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      const queries = (data && data.resources && data.resources.results && data.resources.results.queries) || [];

      if (!products.length && !queries.length) {
        results.innerHTML = `<p class="predictive-search__empty">${wrapper.dataset.noResultsLabel}</p>`;
        results.hidden = false;
        return;
      }

      const suggestionItems = queries
        .map((suggestion) => {
          const suggestionUrl = `${wrapper.dataset.searchUrl}?q=${encodeURIComponent(suggestion.text)}`;
          return `<a class="predictive-search__suggestion" href="${suggestionUrl}">${suggestion.styled_text || suggestion.text}</a>`;
        })
        .join('');

      const productItems = products
        .map((product) => {
          const image = product.featured_image ? product.featured_image.url : product.image;

          return `
            <a class="predictive-search__item" href="${product.url}">
              ${image ? `<img class="predictive-search__item-image" src="${image}" width="60" height="60" alt="" loading="lazy">` : ''}
              <span class="predictive-search__item-content">
                <span class="predictive-search__item-title">${product.title}</span>
                <span class="predictive-search__item-price">${formatPrice(product.price)}</span>
              </span>
            </a>
          `;
        })
        .join('');

      const viewAllUrl = `${wrapper.dataset.searchUrl}?q=${encodeURIComponent(query)}`;

      results.innerHTML = `
        <div class="predictive-search__panels">
          ${suggestionItems ? `
            <div class="predictive-search__panel predictive-search__panel--suggestions">
              <p class="predictive-search__heading">${wrapper.dataset.suggestionsLabel}</p>
              <div class="predictive-search__suggestions">${suggestionItems}</div>
            </div>
          ` : ''}
          ${productItems ? `
            <div class="predictive-search__panel predictive-search__panel--products">
              <p class="predictive-search__heading">${wrapper.dataset.productsLabel}</p>
              <div class="predictive-search__list">${productItems}</div>
            </div>
          ` : ''}
        </div>
        <a class="predictive-search__view-all" href="${viewAllUrl}">${wrapper.dataset.viewAllLabel}</a>
      `;
      results.hidden = false;
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();

      clearTimeout(debounceTimer);

      if (query.length < 2) {
        closeResults();
        return;
      }

      debounceTimer = setTimeout(() => {
        if (predictiveSearchCache.has(query)) {
          renderResults(predictiveSearchCache.get(query), query);
          return;
        }

        activeController?.abort();
        activeController = new AbortController();

        const params = [
          `q=${encodeURIComponent(query)}`,
          'resources[type]=product,query',
          'resources[limit]=6',
          'resources[options][unavailable_products]=last',
        ].join('&');

        fetch(`${baseUrl}.json?${params}`, { signal: activeController.signal })
          .then((response) => response.json())
          .then((data) => {
            predictiveSearchCache.set(query, data);
            renderResults(data, query);
          })
          .catch((error) => {
            if (error.name !== 'AbortError') closeResults();
          });
      }, 200);
    });

    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target)) closeResults();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeResults();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
